var RetryActions;
(function (RetryActions) {
    RetryActions["retry_fetch_success"] = "retry_fetch_success";
    RetryActions["retry_fetch_fail"] = "retry_fetch_fail";
    RetryActions["retry_fetch_error"] = "retry_fetch_error";
    RetryActions["initiate_payment_start"] = "initiate_payment_start";
    RetryActions["initiate_payment_success"] = "initiate_payment_success";
    RetryActions["initiate_payment_failure"] = "initiate_payment_failure";
    RetryActions["process_payment_authorisation_start"] = "process_payment_authorisation_start";
    RetryActions["process_payment_authorisation_success"] = "process_payment_authorisation_success";
    RetryActions["process_payment_authorisation_failure"] = "process_payment_authorisation_failure";
})(RetryActions || (RetryActions = {}));

export { RetryActions };
//# sourceMappingURL=types.js.map
